import { createFileRoute } from "@tanstack/react-router";
import { DefiPoolDetailPage } from "../../features/defi/pages/defi-pool-detail-page";
import type { ProtocolKey } from "../../shared/utils/protocol-data";

export const Route = createFileRoute("/_layout/defi/pool/$tokenAddress/$protocolId")({
  component: DefiPoolDetailPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      protocolKey: search.protocolKey as ProtocolKey | undefined,
      position: search.position as "create" | "manage-supply" | "manage-withdraw" | undefined,
    };
  },
});
